import "theia-sticky-sidebar";
import * as bootstrap from "bootstrap";

jQuery(document).ready(function ($) {
  if ($(window).width() > 991.9) {
    
    //Append table of contents to sitebar
    $(".ap-blog-contents").appendTo(".ap-sidebar");
    
    //Add nav classes to table of conents
    $(".ap-blog-contents li").each(function () {
      $(this).find("a").addClass("nav-link");
    });

    //Make sitebar sticky
    $(".ap-sidebar").theiaStickySidebar({
      additionalMarginTop: 124,
      minWidth: 975,
    });

    if ($(".ap-blog-contents").length) { // conditional inclusion to prevent interfere with tab items on pages
      //Add ScrollSpy to table of contents
      const scrollSpy = new bootstrap.ScrollSpy(document.body, {
        target: ".ap-blog-contents",
        method: "offset",
        offset: 192,
      });
    }
  }

  //Add modal field for tracking purposes
  $('#ask-our-expert').click(function() {
    $('#rfp-form-modal form').append( '<input id="ap-expert" type="hidden" name="ap_expert" value="' + $(this).data('expert') + '">' );
    const targetModal = $(this).data('bs-target');
    const form = $(targetModal).find('form');
    form.attr('data-form-source', 'ask-expert');
  });

  //Remove tracking field on modal close
  $('#rfp-form-modal').on('hide.bs.modal', function () {
    $('#ap-expert').remove();
    // Remove the data-form-source attribute after submission
    $(this).find('form').removeAttr('data-form-source');
  })
});
